<template>
  <van-button
    :color="color"
    :disabled="disabled"
    :size="size"
    :icon="icon"
    @click="onClick"
  >
    {{title || '确定'}}
  </van-button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'var(--depYelColor)'
    },

    icon: String
  },
  methods: {
    onClick () {
      this.$emit('click')
    }
  }
};
</script>

<style scoped lang="less">
  .van-button--big{
    width: 100%;
    height: 50px;
    border-radius: var(--defaultRadius);
  }
  .van-button--small {
    font-size: 12px; 
    padding: 0 10px;
    border-radius: 50px;
  }
  /deep/ .van-icon__image{ 
      height: 24px; 
      width: 24px;
  }
</style>
